// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let AvatarSrcUrl = require("../../../../utils/AvatarSrcUrl.bs.js");
let Avatar__Jsx3 = require("../Avatar/Avatar__Jsx3.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let JsxRuntime = require("react/jsx-runtime");

function wrapSelf(v) {
  return v;
}

function AgentInfo__Jsx3(props) {
  let children = props.children;
  let __wrapAvatar = props.wrapAvatar;
  let __wrapName = props.wrapName;
  let brokerage = props.brokerage;
  let name = props.name;
  let __size = props.size;
  let onClick = props.onClick;
  let size = __size !== undefined ? __size : "small";
  let wrapName = __wrapName !== undefined ? __wrapName : wrapSelf;
  let wrapAvatar = __wrapAvatar !== undefined ? __wrapAvatar : wrapSelf;
  let avatarSrc = Stdlib_Option.getOr(props.avatar, AvatarSrcUrl.placeholder);
  return JsxRuntime.jsxs("div", {
    children: [
      wrapAvatar(JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Avatar__Jsx3.make, {
          onClick: onClick,
          src: avatarSrc,
          name: name,
          size: size === "medium" ? ({
              NAME: "px",
              VAL: 60
            }) : (
              size === "small" ? "small" : (
                  size === "xSmall" ? "tiny" : "large"
                )
            )
        }),
        className: "mr-[15px] shrink-0"
      })),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: wrapName(name),
            className: TailwindMerge.twMerge([
              "font-semibold leading-[1] text-zinc-800",
              Stdlib_Option.isSome(onClick) ? "cursor-pointer" : "",
              size === "xSmall" || size === "small" || size === "medium" ? "text-base" : "text-lg"
            ]),
            onClick: onClick
          }),
          brokerage !== undefined ? JsxRuntime.jsx("div", {
              children: brokerage,
              className: "mt-2 leading-none text-sm font-normal text-zinc-500"
            }) : null,
          Stdlib_Option.getOr(children, null)
        ],
        className: "flex flex-col"
      })
    ],
    className: TailwindMerge.twMerge([
      "flex",
      Stdlib_Option.isSome(children) ? "items-start" : "items-center"
    ])
  });
}

let make = AgentInfo__Jsx3;

exports.wrapSelf = wrapSelf;
exports.make = make;
/* AvatarSrcUrl Not a pure module */
